






















import { Component, Vue, Prop, Emit } from 'vue-property-decorator'
import { UpdateUserInfoWealth} from '@/api'
import { ElForm } from 'element-ui/types/form'
import { VTable, TableHander } from '@/components/table'
import { VImageUpload } from '@/components/upload'
import { TxLocal } from '@/utils/local/TxLocal'
import constant from '@/utils/constant'

@Component({
  components: {
    VTable,
    VImageUpload,
  },
})
export default class UpdateUserInfoRoleDialog extends Vue {
  @Prop({ type: Boolean, default: false }) private appendToBody!: boolean

  @Emit('close')
  private close() {
    const f = this.$refs.form as ElForm
    f.resetFields()
    this.show = false
  }
  private data: any = {
    contributionQty: undefined,
    energyQty: undefined,
    mungBeanQty: undefined,
    note: undefined
  }
  private show = false
  private isEdit = false
  private memberList: Array<any> = []



  public async open(data: any, isEdit: boolean) {
    this.show = true
    this.isEdit = isEdit
    this.data.userId = data.id;
  }

  private requiredRule = { required: true, message: '不能为空', trigger: 'blur' }
  private rules = {
    type: [this.requiredRule],
  }


  public async save() {

    const form = this.$refs.form as ElForm
    form.validate(async (valid: boolean) => {
      if (valid) {
        const load = this.$loading({
          lock: true,
          text: '数据处理中',
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0.7)'
        });
        try{
          let result = {}
          if(this.isEdit){
            result = await UpdateUserInfoWealth(this.data)
          } 
          if(result){
            this.close()
          }
        }finally{
          load.close()
        }

      } else {
        this.$message.error("表单存在错误，不能保存")
        return false
      }
    })
  }
}
